import { useCallback } from "react";
import { useRequest } from "@danishagro/shared/src/hooks/useRequest.hook";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { FetchOptions } from "@danishagro/shared/src/interfaces/fetchOptions.interface";

type InviteUser = (
    parameters: {
        email: string;
        culture?: string;
        cvr?: string;
        roleAlias: string;
        customerNumbers: string[];
    },
    options?: FetchOptions
) => Promise<unknown>;

export const useInviteApi = () => {
    const request = useRequest();
    const { cvrNumber } = useAppData();

    const inviteUser: InviteUser = useCallback(
        (parameters, options?) =>
            request.post(`api/invite/inviteuser`, { cvr: cvrNumber, ...parameters }, options),
        [request, cvrNumber]
    );

    return {
        inviteUser,
    };
};
